import React from 'react'
import { Modal, Container, Footer, ContainerExclusao, FooterExclusao } from "./styles"

const ModalInfo = ({ onClose = () => { }, handleModalStorage = () => { }, children, title, buttonText, MessageInline, exclusaoParam, width, height, footerRender = null }) => {
    return (
        <Modal>
            <ContainerExclusao >
                <button onClick={onClose}>X</button>
                <h1>{title}</h1>
                <br />
                <p>{children}</p>
                <br />
                <FooterExclusao>
                    {footerRender ? footerRender : <div>
                        <button onClick={onClose}>{buttonText}</button>
                        <p onClick={handleModalStorage}>{MessageInline}</p>
                    </div>}
                </FooterExclusao>
            </ContainerExclusao>
        </Modal>
    );
}

export default ModalInfo;